'use strict';


var not_implemented = (function (s){ throw new Error(s)});

exports.not_implemented = not_implemented;
/* not_implemented Not a pure module */



//////////////////
// WEBPACK FOOTER
// /Users/liubko/.nvm/versions/node/v6.10.0/lib/node_modules/bs-platform/lib/js/caml_missing_polyfill.js
// module id = 36
// module chunks = 0